import React from "react";
import {
  TooltipProvider,
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from "@/components/ui/overlays";

interface NodeTooltipProps {
  children: React.ReactNode;
  data: any;
}

export function NodeTooltip({ children, data }: NodeTooltipProps) {
  return (
    <TooltipProvider>
      <Tooltip delayDuration={300}>
        <TooltipTrigger asChild>
          <div>{children}</div>
        </TooltipTrigger>
        <TooltipContent className="p-3 space-y-1 bg-card border border-border text-foreground shadow-lg">
          <p className="font-bold text-xs text-text-primary">{data.label}</p>
          {data.subtext && (
            <p className="text-[10px] text-text-secondary">{data.subtext}</p>
          )}
          {data.status && (
            <p className="text-[9px] font-semibold text-text-muted mt-1">
              Stato:{" "}
              <span className="text-text-primary capitalize">
                {data.status}
              </span>
            </p>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
